module.exports = __webpack_public_path__ + "img/outcome_bad.a6bb9dc7.jpeg";